const VALUE_MAP = {
  "111-111": {
    "Rudas korpusas/Rudas stalčius": "VID",
    "Tamsus korpusas/Tamsus stalčius": "TA2",
    "Tamsus korpusas/Šviesus stalčius": "TAM",
    "Šviesus korpusas/Šviesus stalčius": "SVI",
  },
  "222-222": {
    "Rudas korpusas": "VID",
    "Tamsus korpusas": "TAM",
    "Šviesus korpusas": "SVI",
  },
};

const getNormalizedParamValue = (val, configurationId, extraSuffixes) => {
  if (val == null) return "";
  const configMap = VALUE_MAP[configurationId];
  if (configMap && configMap[val]) {
    return configMap[val];
  }
  if (extraSuffixes && extraSuffixes[val]) {
    return extraSuffixes[val];
  }
  return typeof val === "string" ? val.slice(0, 3).toUpperCase() : String(val);
};

export default getNormalizedParamValue;
